<template>
  <div>
    <v-container container--fluid grid-list-xl>

      <v-card color="#42424211">
        <v-container>
          <v-row align="center" justify="center" class="my-0">
            <v-col cols="9" md="4">
              <v-file-input
                v-model="excelFile"
                label="Error report input"
                hint="select a .xlsx file"
                accept=".xlsx"
                @click:clear="resetData"
              ></v-file-input>
            </v-col>
            <v-col cols="2" md="2">
              <v-btn
                :disabled="!excelFile"
                color="primary"
                class="ma-2 white--text"
                @click="readXLSX"
              >
                <v-icon dark>fas fa-file-import</v-icon>
              </v-btn>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="8" md="4">
              <v-btn
                :disabled="!isLoaded"
                color="primary"
                block primary
                @click="submitData"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-expansion-panels>
          <v-expansion-panel style="background-color: #00000000" :disabled="!isLoaded">
            <v-expansion-panel-header v-slot="{ open }">
              <v-card-title class="pa-0">Statistics</v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <DoughnutChart
                  style="height: 40vh"
                  ref="chart"
                  :chart-data="chartData"
                  :options="options"
                ></DoughnutChart>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-spacer></v-spacer>

      <v-container>
<!--        <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">-->
          <v-col cols="9" sm="9" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
<!--        </v-row>-->
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="data"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Error reports</v-toolbar-title>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-container>
    </v-container>
  </div>
</template>

<script>
  import Excel from 'exceljs/dist/exceljs'
  import DoughnutChart from "../../../util/ErrorReport/DoughnutChart";
  import axios from "axios";

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateRotate: false
    }
  }
  const errorList = ['GE', 'TW', 'N/A', 'DT', 'D', 'IN', 'ND', 'C', 'PR','DEREC','RENREC','G','NI','EAR']
  const colorList = ["#00a7d3", "#1357a4","#424242","#aeb8d6", "#A83271", "#662E9B", "#F9C80E", "#EA3546", "#F86624" ]

  export default {
    components: {DoughnutChart},
    name: "ErrorReportPage",
    data () {
      return {
        excelFile: null,
        idToTableItem: {},
        data: [],
        loading: false,
        isLoaded: false,
        statPanel: false,
        search:'',
        headers : [
          {text: 'Id', value: 'id', align: 'center'},
          {text: 'Customer City', value: 'customer_city', align: 'center'},
          {text: 'Customer Postcode', value: 'customer_postcode', align: 'center'},
          {text: 'Error Subcategory', value: 'mapped_error_subcategory', align: 'center'},
          {text: 'Error Description', value: 'error_description', align: 'center'},
          {text: 'Detail', value: 'mapped_detail_1', align: 'center'},
          {text: 'BC Error', value: 'bc_error', align: 'center'},
        ],
        HFtoBCErrorMapping: {
          'Logistics': {
            'Early/Late Delivery': {
              'Early Delivery - Before Scheduled Delivery Day': {'NULL': 'EAR','-1':'EAR'},
              'Early Delivery - Same Day':{'NULL': 'EAR'},
              'Late Delivery - Same Day':{'Box Received': 'TW', 'Box Not Received': 'TW','-1':'TW'},
              'Late Delivery - 1 Day':{'Box Received': 'DEREC', 'Box Not Received': 'RENREC','-1':'DEREC'},
              'Late Delivery - 2 Days':{'Box Received': 'DEREC', 'Box Not Received': 'RENREC','-1':'DEREC'},
              'Production Delay':{'NULL': 'N/A'},
              'Line-haul Delay':{'NULL': 'N/A'},
              'Goods Out Error':{'NULL': 'N/A'},
              'Ordering Issue':{'NULL': 'N/A'}
            },
            'No Delivery': {
              'Box Not Found but Marked as Delivered': {'Photo': 'GE', 'Signature':'GE', 'No Photo or Signature provided': 'GE'},
              'No Delivery Tracking/Manifest': {'NULL': 'NI'},
              'Damaged and Returned': {
                'crushed': 'GNR',
                'Dented': 'GNR',
                'Leaking': 'GNR',
                'Open': 'GNR',
                'Torn/Ripped': 'GNR',
                'Wet': 'GNR',
                'NULL': 'GNR',
                'Other': 'GNR'
              },
              'Courier Network Error': {'Misroute': 'GNR', 'Left at Hub/Depot':'GNR'},
              'Delivered to Wrong Address': {
                '-1':'D',
                'Wrong Number': 'D',
                'Wrong Street':'D',
                'Wrong Postcode':'D',
                'NULL':'D'
              },
              'Driver Did Not Follow Delivery Label Instructions': {
                'Left in Wrong Place': 'IN',
                'Left with Neighbour':'IN',
                'Did not knock/ring':'IN'
              },
              'Force Majeure': {'NULL': 'ND','Early Late Delivery':'ND','Other':'ND'},
              'Production Issue': {'NULL': 'G'},
              'Logistics Courier Network Error':{'Other':'GNR'},
              'Internal Production Error Goods Out':{'NULL': 'GNR','-1':'GNR'}
            },
            'Delivery Issues': {
              'Damaged': {
                'crushed':'DT',
                'Dented': 'DT',
                'Leaking': 'DT',
                'Open': 'DT',
                'Repackaged by Courier': 'DT',
                'Torn/Ripped': 'DT',
                'Wet': 'DT',
                'Other': 'DT',
              },
              'Delivered to Wrong Address': {
                'Wrong Number': 'D',
                'Wrong Street':'D',
                'Wrong Postcode':'D',
                'NULL':'D',
                '-1':'D'
              },
              'Driver Didn\'t Follow Delivery/Label Instructions': {
                'Left In Wrong Place': 'IN',
                'Left With Neighbour':'D',
                'Did Not Knock Or Ring':'IN'
              },
              'Driver Did Not Follow Delivery Label Instructions':{
                'Left In Wrong Place': 'IN',
                'Left With Neighbour':'D',
                'Did Not Knock Or Ring':'IN'
              },
              'Driver Behaviour': {
                'Mishandled Box': 'DT',
                'Rude or Inappropriate Behaviour': 'B',
                'Property Damage': 'PR',
                'Other': 'B'
              },
              'Driver Delivery & Behaviour': {
                'Mishandled Box': 'DT',
                'Rude or Inappropriate Behaviour': 'B',
                'Property Damage': 'PR',
                'Other': 'B'
              }
            },
          }
        },

        chartData: {
          labels: errorList,
          datasets: [
            {
              data: [1,1,1,1,1,1,1,1,1],
              backgroundColor: colorList,
            }
          ]
        },
        options
      }
    },
    methods: {
      getBCError( delivery ){
        const cat1 = delivery['mapped_error_category'];
        const cat2 = delivery['mapped_error_subcategory'];
        const cat3 = delivery['mapped_complaint'];
        const cat4 = delivery['mapped_detail_1'];
        if (this.HFtoBCErrorMapping[cat1]){
          if (this.HFtoBCErrorMapping[cat1][cat2]){
            if (this.HFtoBCErrorMapping[cat1][cat2][cat3]){
              if(this.HFtoBCErrorMapping[cat1][cat2][cat3][cat4]){
                return this.HFtoBCErrorMapping[cat1][cat2][cat3][cat4];
              } else if(this.HFtoBCErrorMapping[cat1][cat2][cat3][cat4] === undefined) {
                return this.HFtoBCErrorMapping[cat1][cat2][cat3]['NULL'];
              } else {
                console.log('issue for cat4 with: ' + cat1 + ' > ' + cat2 + ' > ' + cat3 + ' > ' + cat4);
              }
              // if (this.HFtoBCErrorMapping[cat1][cat2][cat3][cat4]){
              //   return this.HFtoBCErrorMapping[cat1][cat2][cat3][cat4];
              // } else {
              //   console.log('issue for cat4 with: ' + cat1 + ' > ' + cat2 + ' > ' + cat3 + ' > ' + cat4);
              // }
            }else {
              console.log('issue for cat3 with: ' + cat1 + ' > ' + cat2 + ' > ' + cat3);
            }
          }else {
            console.log('issue for cat2 with: ' + cat1 + ' > ' + cat2);
          }
        }else {
          console.log('issue for cat1 with: ' + cat1);
        }
        return '';
      },

      resetData(){
        this.statPanel = false;
        this.isLoaded = false;
        this.data = [];
      },

      computeStat(){
        const errorCount = {};
        errorList.forEach( error => {
          errorCount[error] = 0;
        })

        this.data.forEach( (deliveries) => {
          errorCount[deliveries['bc_error']] = errorCount[deliveries['bc_error']] + 1;
        });
        console.log(errorCount);
        const errorCountList = [];
        for (let idx in errorCount){
          errorCountList.push( errorCount[idx]);
        }
        this.chartData.datasets[0].data = errorCountList;
      },
      readXLSX(){
        const reader = new FileReader();
        const wb = new Excel.Workbook();
        this.loading = true;

        reader.readAsArrayBuffer(this.excelFile);
        reader.onload = () => {
          const buffer = reader.result;
          wb.xlsx.load(buffer).then(workbook => {
            workbook.eachSheet((sheet, id) => {
              sheet.eachRow((row, rowIndex) => {
                if (rowIndex === 1){
                  row.values.forEach( (item, itemId) => {
                    this.idToTableItem[itemId] = item
                  });
                } else {
                  const delivery = {};
                  row.values.forEach( (item, itemId) => {
                    if (this.idToTableItem[itemId]){
                      delivery[this.idToTableItem[itemId]] = item;
                    }
                  });
                  delivery['bc_error'] = this.getBCError(delivery);

                  if (!this.data.map( del => {return del.id}).includes(delivery.id)){
                    this.data.push(delivery);
                  }

                }
              });
              this.computeStat();
              this.loading = false;
              this.isLoaded = true;
            });
          });
        }
      },
      submitData(){
        let proceedAction = 0;
        let rejectedAction = 0
        const totalAction = this.data.length;
        this.loading = true;
        this.data.forEach( delivery => {
          axios.get(process.env.API_URL + '/deliveries?serial=' + delivery.box_id)
            .then((response) => {
              if (response.data[0]) {
                const delData = response.data[0];
                const trackingNum = response.data[0].tracking;
                let body = {
                  source: 'client',
                  code_source: delivery.bc_error,
                  notes: delivery['error_description'],
                  approved: false,
                  verified: false,
                };

                if (['B'].includes(delivery.bc_error)) {
                  body.verified = true;
                }

                if (['TW', 'EAR', 'DEREC'].includes(delivery.bc_error)) {
                  body.approved = false;
                  body.verified = true;

                  const actualTime = delData.actual_time ? new Date(delData.actual_time.replace(' ', 'T')).getTime() : null;
                  const windowStart = delData.time_window_start ? new Date(delData.time_window_start.replace(' ', 'T')).getTime() : null;
                  const windowEnd = delData.time_window_end ? new Date(delData.time_window_end.replace(' ', 'T')).getTime() : null;

                  if (actualTime && windowStart && windowEnd) {
                    const startMinus1h = windowStart - (3600 * 1000); // time windows before 1 hour
                    const endPlus1h = windowEnd + (3600 * 1000);     // time windows after 1 hour

                    // in  [Start - 1h, End + 1h]
                    if (actualTime >= startMinus1h && actualTime <= endPlus1h) {
                      body.reject_reason = 'DW1H';
                    }
                  }
                }

                axios.put(process.env.API_URL + '/errors/' + trackingNum, body)
                  .then((response) => {
                    proceedAction++;
                    console.log(proceedAction);
                    if (proceedAction === totalAction){
                      this.$store.commit('displaySnackbar', 'Proceeded ' + proceedAction + ' actions but rejected ' + rejectedAction);
                      this.loading = false;
                    }
                  })
                  .catch((response) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    this.loading = false;
                  });
              } else {
                proceedAction++;
                rejectedAction++;
                if (proceedAction === totalAction){
                  this.$store.commit('displaySnackbar', 'Proceeded ' + proceedAction + ' actions but rejected ' + rejectedAction);
                  this.loading = false;
                }
                console.log(delivery.box_id, response)
                this.$store.commit('displaySnackbar', 'Delivery data not specified for delivery id ' + delivery.box_id);
              }
            })
            .catch((response) => {
              proceedAction++;
              rejectedAction++;
              console.log(proceedAction + ' but delivery not found');
              this.$store.commit('displaySnackbar', 'Delivery not found ' + response.response.data.error);
            })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ExcelReports/ErrorReportPage.vue